// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-rows[data-v-e5693cf6]{display:flex;flex-direction:column;height:100%}.plugin-header[data-v-e5693cf6]{flex:0}.plugin-content[data-v-e5693cf6]{flex:1;background-color:#fff;overflow-y:auto}.plugin-footer[data-v-e5693cf6]{flex:0}", ""]);
// Exports
module.exports = exports;
